















import { Vue, Prop, Component, Inject } from 'vue-property-decorator'
import { getSelectedCityId } from '@utils/index'

@Component
export default class TitleBar extends Vue {
  @Prop({ default: '南京' }) readonly cityName!: string
  @Prop({ default: '搜商家或服务' }) readonly placeholder!: string

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_search')
  clickid_search!: string
  @Inject('clickid_city')
  clickid_city!: string

  get searchExposure() {
    return `${this.clickid_search}||${JSON.stringify({ citycode: getSelectedCityId() })}`
  }
  search() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_search, positionParam: { citycode: getSelectedCityId() } })
    this.$router.push({ name: 'search' })
  }

  get cityExposure() {
    return `${this.clickid_city}`
  }
  cityChoose() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_city })
    this.$router.push({ name: 'city-choose', query: { referer: encodeURIComponent(location.href), refresh: 'no' } })
  }
}
